import * as React from 'react';
import { USER_ROLES } from '@/constants/user-roles';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import Accounts from '@/pages/v2/settings/accounts';
import { AccountAdministratorsPage } from '@/pages/v2/settings/accounts/administrators';
import { AccountAdministratorPage } from '@/pages/v2/settings/accounts/administrators/administrator';
import { AccountSystemUsersPage } from '@/pages/v2/settings/accounts/system-users';
import { AccountSystemUserPage } from '@/pages/v2/settings/accounts/system-users/user';
import { AccountCommunitiesPage } from '@/pages/v2/settings/accounts/communities';
import { AccountCommunityPage } from '@/pages/v2/settings/accounts/communities/community';
import { Layout as AccountSettingsLayout } from '@/pages/v2/settings/accounts/components/layout';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { ACCOUNT_ROLES } from '@/constants/account-roles';

export const route: RouteObject = {
  path: paths.settings.account.index,
  element: (
    <DashboardLayout>
      <RoleGuard
        displayUnauthorized
        requiredAccountRoles={[
          ACCOUNT_ROLES.ACCOUNT_ADMIN,
          ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ACCOUNT_ROLES.ACCOUNT_OWNER,
        ]}
      >
        <Outlet />
      </RoleGuard>
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <AccountSettingsLayout metadata={{ title: 'Account Settings' }}>
          <Accounts />
        </AccountSettingsLayout>
      ),
    },
    {
      path: paths.settings.account.administrators.index,
      children: [
        {
          index: true,
          element: (
            <AccountSettingsLayout metadata={{ title: 'Administrators' }}>
              <AccountAdministratorsPage />
            </AccountSettingsLayout>
          ),
        },
        {
          path: paths.settings.account.administrators.administrator(':administratorId'),
          element: (
            <AccountSettingsLayout metadata={{ title: 'Users' }}>
              <AccountAdministratorPage />
            </AccountSettingsLayout>
          ),
        },
      ],
    },
    {
      path: paths.settings.account.systemUsers.index,
      children: [
        {
          index: true,
          element: (
            <AccountSettingsLayout metadata={{ title: 'System Users' }}>
              <AccountSystemUsersPage />
            </AccountSettingsLayout>
          ),
        },
        {
          path: paths.settings.account.systemUsers.user(':userId'),
          element: (
            <AccountSettingsLayout metadata={{ title: 'User Details' }}>
              <AccountSystemUserPage />
            </AccountSettingsLayout>
          ),
        },
      ],
    },
    {
      path: paths.settings.account.communities.index,
      children: [
        {
          index: true,
          element: (
            <AccountSettingsLayout metadata={{ title: 'Communities' }}>
              <AccountCommunitiesPage />
            </AccountSettingsLayout>
          ),
        },
        {
          path: ':communityId',
          element: (
            <AccountSettingsLayout metadata={{ title: 'Community Details' }}>
              <AccountCommunityPage />
            </AccountSettingsLayout>
          ),
        },
      ],
    },
  ],
};
